/**
 * Cleans up notation the agent writes that a reader should not have to see.
 *
 * The model emits statistics in LaTeX-ish form — `$N = 35,300$`, `$z = -3.3$`
 * — because that is how they appear in the papers it learned from. Nothing
 * renders TeX here, so the dollar signs reach the screen as punctuation and
 * the sentence reads as though a price has gone wrong.
 *
 * Stripping them is a display decision, not a correction: the numbers are
 * unchanged, only the delimiters go.
 */

/**
 * `$…$` around a short run with no line break and no second dollar.
 *
 * Deliberately narrow, because a real amount must survive. `$100k` has no
 * closing delimiter and never matches; `$12.99 and $14.99` would, so the
 * pattern also requires a `=`, a comparison, or a lone symbol — the shapes
 * statistics take and prices do not.
 */
const MATH = /\$([^$\n]{1,60}?)\$/g;
const STATISTICAL = /[=<>≤≥]|\bp\b|\bz\b|\bN\b|\bn\b/;

export const tidyNarrative = (text) => {
  if (typeof text !== "string" || !text.includes("$")) return text;
  return text.replace(MATH, (whole, inner) =>
    STATISTICAL.test(inner) ? inner : whole,
  );
};

export default tidyNarrative;
